import React from "react";
import "./homeAboutUs.css";
import { director_image } from "../../assets";

const HomeAboutUs = () => {
  return (
    <div className="homeAbout_sectionOneCont">
      <div className="homeAbout_sectionOne_gen">
        <div className="homeAbout_startedHeader">Organization Profile</div>
        <div className="homeAbout_startedSub">
          A Legacy of Protection, Discipline, and Community Service
        </div>

        <div className="homeAbout_paraGen">
          <div>
            <div className="homeAbout_director_image">
              <div className="homeAbout_director_image____">
                <img src={director_image} />
              </div>
            </div>
            <div className="homeAbout_director_name">
              Com. Chijioke Ugochukwu
            </div>
            <div className="homeAbout_director_title">Director General</div>
          </div>

          <div className="homeAbout_para">
            Established in 2019 under Royal Line Promotion and Production by the
            late Evangelist Francis Akintoye Omole, SWADAA Security and Guards
            Services has built a reputation for professionalism, discipline, and
            public safety. Under the leadership of Director General, Comrade
            Chijioke Ugochukwu, we provide reliable security solutions while
            maintaining strong collaborations with the National Drug Law
            Enforcement Agency (NDLEA), the Nigeria Police Force, and other
            government institutions.
            <div className="heading__aboutt">Our Mission </div>
            To provide dependable security guard services that protect lives,
            properties, businesses, and events through highly trained personnel,
            professionalism, integrity, and proactive security measures.
            <div className="heading__aboutt">
              Why Clients Trust SWADAA Security and Guards Services
            </div>
            Our clients choose us because we combine experienced security
            personnel with a commitment to excellence. We prioritize prevention,
            rapid response, accountability, and exceptional customer service,
            giving every client the confidence that their people and assets are
            in safe hands.
            <div className="heading__aboutt">
              Government Recognition & Partnerships
            </div>
            In 2007, the organization affiliated with the National Drug Law
            Enforcement Agency, receiving training and recognition. This enabled
            further outreach, including educating religious institutions and
            healthcare professionals, and distributing educational materials on
            drug abuse and related social issues.
            <div className="heading__aboutt">
              Collaboration and Achievements
            </div>
            SWADAA Express collaborates with several government bodies,
            including the National Drug Law Enforcement Agency, the Nigeria
            Police, and various state governments, to combat drug abuse and its
            associated social ills. The organization also seeks international
            partnerships to enhance its efforts in making society drug and
            crime-free.
            <div className="heading__aboutt">Our Commitment</div>
            We are dedicated to creating safer environments for businesses,
            residential communities, institutions, and events. Every assignment
            is carried out with professionalism, vigilance, and respect,
            ensuring our clients receive reliable protection and complete peace
            of mind.
            <div className="heading__aboutt">Our Empowerment Programme </div>
            Through our programs for women, youth, and widows, we provide
            valuable resources, training, and support to help individuals reach
            their full potential. From skills development workshops and
            entrepreneurship training to mentorship programs and financial
            assistance, we strive to empower marginalized groups and promote
            inclusivity, equality, and self-sufficiency.
          </div>
        </div>

        {/* <a
          href="https://api.whatsapp.com/send?phone=+2348033477608&text=I%20am%20reaching%20out%20to%20explore%20your%20business%20offering."
          target="_blank"
          className="getStarted_btn"
          style={{ textDecoration: "none" }}
        >
          Lets Get Started
        </a> */}
      </div>
    </div>
  );
};

export default HomeAboutUs;
